var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-list"},_vm._l((_vm.serverList),function(server,i){return _c('div',{key:i,staticClass:"wrap"},[_c('card-item',{attrs:{"data":server}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }